module.exports = __webpack_public_path__ + "img/Busbuddy1.0b9f70c4.jpg";